<template>
	<div class="footer">
		<div class="wrap_inner">
			<p class="supporter"><a href="tel:0215667711"><span>고객콜센터 1566-7711</span></a><a href="http://www.meritzfire.com" target="_blank"><span>메리츠화재 홈페이지</span></a></p>
			<div class="infoArea">
				<span class="info">대표이사 김중현 사업자번호 116-81-03752</span>
				<span class="copyrights" @click="pass">&copy;meritz Fire&amp;Marine Insurance Co,Ltd. <span class="upper">All Rights Reserved.</span> </span>
			</div>
		</div>
	</div>
</template>

<script>
export default {
    name: 'Footer',
    props: {
    },
	setup(props, {emit}) {
		let passCnt = 0;

		const pass = () => {
			passCnt++;
			if(passCnt >= 5){
				emit('pass');
			}
		}

		return {
			pass
		}
	}
}
</script>